import React, { useEffect, useState } from "react";
import Sidebar from "./sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios"
import api from "../api/axios";
import { toast } from "react-toastify";
function Methodologie() {
  const navigate = useNavigate()
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [data, setData] = useState([])
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteID, setDeleteID] = useState(null);
  const [deletePopup, setDeletePopup] = useState(false);

  const filteredData = data.filter((item) =>
    item.methodology.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const fetchMethodogy = async () => {
    const res = await api.get("/getmethodology");
    setData(res.data)
  }

  useEffect(() => {
    fetchMethodogy()
  }, [])

  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const handleEdit = (id) => {
    const dataToEdit = data.find((item) => item._id === id)
    navigate("/methodologie/addNewmethodology", { state: { data: dataToEdit } })
  }

  const handleDelete = (id) => {
    setDeletePopup(true);
    setDeleteID(id)
  }

  const handleDeleteData = async (id) => {
    try {
      await api.delete(`/deletemethodology/${id}`);
      setDeletePopup(false);
      await fetchMethodogy();
      toast.success("Methodology delete successfully");
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Methodologies 👋🏼
              </h1>
            </div>

            {deletePopup && (
              <div className="fixed inset-0 top-0 left-0 w-screen h-screen z-[9999]  flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white p-6 rounded shadow-lg">
                  <p className="mb-4">
                    Are you sure you want to delete this item?
                  </p>
                  <div className="flex  justify-stretch gap-4">
                    <button
                      className="px-4 py-2 w-full bg-gray-300 rounded"
                      onClick={() => setDeletePopup(false)}
                    >
                      No
                    </button>
                    <button
                      className="px-4 py-2 w-full bg-[#E84000] text-white rounded"
                      onClick={() => handleDeleteData(deleteID)}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="border mt-5 2xl:rounded-[30px] rounded-[20px] px-10 py-8 bg-white shadow-sm">
              <div className="flex justify-end">
                <div className="flex items-center flex-wrap gap-1">
                  <form
                    className="filterinput"
                    action=" "
                  >
                    <input
                      type="text"
                      name="inputdata"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="bg-[#F9FBFF]  sm:px-5 max-sm:w-[68%] pl-3 2xl:py-2 py-[0.40rem] border border-gray-300  outline-none focus:ring-2 focus:ring-[#C65B1D] rounded-lg text-xs max-md:my-1"
                      placeholder="Search here..."
                    />

                  </form>

                  <button
                    onClick={() => navigate('/methodologie/addNewmethodology')}
                    className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                  >
                    Add Methodologies
                  </button>
                </div>

              </div>
              <table className="w-[500px] border-collapse border-spacing-0 mt-[50px]">
                <thead>
                  <tr className="text-[#b5b7c0] m-12 font-medium">
                    <th>Sr no</th>
                    <th>Methodology</th>
                    {/* <th>GST (%)</th>
                    <th>Total Projects</th> */}
                    <th className="w-20">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.methodology}</td>
                      {/* <td>{item.gst}</td>
                      <td>10</td> */}
                      <td className="">
                        <i
                          onClick={() => handleEdit(item._id)}
                          className="fa-solid cursor-pointer fa-pen-to-square text-[#B5B7C0]"
                        ></i>
                        <i
                          onClick={() => handleDelete(item._id)}
                          className="fa-solid cursor-pointer fa-trash-can text-[#B5B7C0] ml-4"
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Methodologie;
